import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { LoginStore } from "../../stores/login/LoginStore";
import Cookies from 'universal-cookie';
import { GenerateStore } from "../../stores/2fa/GenerateStore";
import Auth2faPage from "../2fa/Auth2faPage";
import { toast } from "react-toastify";
import { AppIcon } from "../utils/AppIcon";

@observer
export class LoginAdmPage extends React.Component<{}, {}> {
  obs = observable({
    email: "" as string,
    password: "" as string,
    token: "" as string,
    mostraSenha: false,
  })

  constructor(props: any) {
    super(props);
  }

  handleCreateConta() {
    AppStore.setLocation("/conta/criar");
  }

  handleRestorePassword() {
    AppStore.setLocation("/esqueci-minha-senha");
  }

  isValida() {

    if (this.obs.email == "") {
      toast.warning("E-mail obrigatório!", {});
      return false

    } else {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!regex.test(this.obs.email)) {
        toast.warning("E-mail inválido!", {});
        return false
      }
    }

    if (this.obs.password == "") {
      toast.warning("Senha obrigatório!", {});
      return false
    }

    if (this.obs.token == "") {
      toast.warning("Token obrigatório!", {});
      return false

    }

    return true

  }

  async handleAcessarSistema() {
    let isValida = this.isValida()

    if (isValida) {

      let ipv4: string = ""

      await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          ipv4 = data.ip;
        })
        .catch(error => ipv4 = "")

      let str_mac = ""

      try {
        const res = await fetch('http://127.0.0.1:6060/mac');

        const dados = await res.json()

        str_mac = dados.str_mac

      } catch (error) {

        str_mac = ""

      }

      let params = {
        email: this.obs.email,
        password: this.obs.password,
        token: this.obs.token,
        ipv4: ipv4,
        mac_address: str_mac
      }

      let isOk: boolean = await LoginStore.handleLogin(params)

      if (isOk && !LoginStore.obs.byPass) {

        GenerateStore.obs.open2fa = true

      } else if (!isOk && !LoginStore.obs.byPass) {

      } else {

        let params = {
          email: this.obs.email,
          senha: this.obs.password,
          token: this.obs.token,
          representante: false
        }

        let resp = await LoginStore.handleAdmLogin(params)

        if (resp.ok) {
          const cookies = new Cookies();
          cookies.set('goto', resp.token, { path: '/', maxAge: 3600 });
          cookies.set('goto_socket', resp.token_socket, { path: '/', maxAge: 3600 });
          cookies.set('goto_adm', resp.token_adm, { path: '/', maxAge: 3600 });

          window.location.href = resp.redirect

        } else {
          toast.error(resp.msg, {});
        }

      }

    }
  }

  toggleMostraSenha = () => {
    this.obs.mostraSenha = !this.obs.mostraSenha
  }

  handleSearchOnKeyEnter(e) {
    if (e.key === 'Enter') {
      this.handleAcessarSistema()
    }
  }

  render() {

    const lockButton = (
      <Button
        icon={this.obs.mostraSenha ? <AppIcon name="visibility_off" color="#526f74" /> : <AppIcon name="visibility" color="#526f74" />}
        onClick={this.toggleMostraSenha}
        className="btn-eyes"
      />
    );

    return (
      <>

        {GenerateStore.obs.open2fa ?

          <Auth2faPage email={this.obs.email} password={this.obs.password} token={this.obs.token} />

          :

          <div className="container-fluid container-login">
            <MDBRow>
              <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
                <div className="login-img">
                  <img src="/images/logo-novo.png" className="img-responsive" />
                </div>

                <h3 className="title-login" style={{ textAlign: "center" }}>Acesso ao Sistema</h3>

                <FormGroup
                  className="form-group"
                  label="E-mail">
                  <InputGroup type="text" onChange={(e: any) => this.obs.email = e.target.value} placeholder="email@email.com" className="input-email" onKeyPress={this.handleSearchOnKeyEnter.bind(this)} />
                </FormGroup>

                <FormGroup
                  className="form-group"
                  label="Senha">
                  <InputGroup
                    rightElement={lockButton}
                    type={this.obs.mostraSenha ? "text" : "password"}
                    value={this.obs.password}
                    onChange={(e: any) => this.obs.password = e.target.value}
                    placeholder="***********"
                    className="input-senha"
                    onKeyPress={this.handleSearchOnKeyEnter.bind(this)}
                  />
                  <div style={{ textAlign: "right" }}>
                    <label style={{ fontSize: "12px", fontWeight: 600, cursor: "pointer" }} onClick={() => this.handleRestorePassword()}>Esqueci minha senha</label>
                  </div>
                </FormGroup>

                <FormGroup
                  className="form-group"
                  label="Token usuário">
                  <InputGroup type="password" onChange={(e: any) => this.obs.token = e.target.value} placeholder="Token usuário" className="input-senha" onKeyPress={this.handleSearchOnKeyEnter.bind(this)} />
                </FormGroup>

                <div className="actions-form" style={{ marginBottom: 20 }}>
                  <Button className="btn btn-login" onClick={() => this.handleAcessarSistema()}>Acessar</Button>
                </div>

                <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                  <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                  <div>© 2023 . Todos os Direitos Reservados.</div>
                </div>

              </MDBCol>

              <MDBCol md="6" className="fundo-login">
                <div className="fundo-bg"></div>
              </MDBCol>
            </MDBRow>

          </div>
        }
      </>
    );
  }
}

export default LoginAdmPage;
